
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import EditCommodityModal from "@/components/widgets/Modals/EditCommodityModal.vue";
import notifications from "../../lib/notifications";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";

const orderModule = getModule(OrderModule);

@Component({
  components: {
    EditCommodityModal
  }
})
export default class OrderCommodities extends Vue {
  editedCommodity: Object = {};

  @Ref() readonly editModal!: EditCommodityModal;

  addCommodity() {
    this.editModal.show(null);
  }

  async remove(commodity) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      `Are you sure you want to remove the commodity? This action cannot be undone.`
    );

    if (confirmed) {
      try {
        await orderModule.removeCommodity({
          commodityCode: commodity.commodityCode,
          headerNumber: orderModule.currentOrder.headerNumber
        });
        notifications.success("Commodity Removed", "Commodity successfully removed from order");
      } catch (ex) {
        notifications.error("Remove Commodity", "Failed to remove commodity from order", ex);
      }
    }
  }

  addOrderNote() {
    this.$emit("addNote");
  }

  newEditedCommodity() {
    this.editedCommodity = {};
  }

  edit(commodity) {
    this.editModal.show(commodity);
  }

  get deliveryForId() {
    return orderModule.currentOrder.deliveryForId;
  }

  get commodities() {
    return orderModule.currentOrderCommodities;
  }

  get totalQuantityForOrderCommodities() {
    return orderModule.totalQuantityForOrderCommodities;
  }

  get totalChargedQuantityForOrderCommodities() {
    return orderModule.totalChargedQuantityForOrderCommodities;
  }

  get totalUomForOrderCommodities() {
    return orderModule.totalUomForOrderCommodities;
  }

  get totalVolumeForOrderCommodities() {
    return orderModule.totalVolumeForOrderCommodities;
  }

  get totalVolumeUomForOrderCommodities() {
    return orderModule.totalVolumeUomForOrderCommodities;
  }

  get totalWeightForOrderCommodities() {
    return orderModule.totalWeightForOrderCommodities;
  }

  get totalWeightUomForOrderCommodities() {
    return orderModule.totalWeightUomForOrderCommodities;
  }
}
